import { track } from '@amplitude/analytics-browser';
import { EMAIL_NOT_FOUND } from 'features/Yucollect/utils/constant';
import { useAppSelector } from 'utils/hooks/useAppSelector';

const useAmplitude = () => {
  const entityId = useAppSelector((state) => state.userConfiguration.entityId);
  const userEmail = useAppSelector(
    (state) => state.userEntities.userData?.email || EMAIL_NOT_FOUND
  );

  const trackEvent = (
    eventName: string,
    requestObject?: Record<
      string,
      string | number | Record<string, unknown>[] | any
    >
  ) => {
    track(eventName, {
      email: userEmail,
      entity: entityId,
      ...(requestObject || {}),
    });
  };

  return {
    trackEvent,
  };
};

export default useAmplitude;
